import React from 'react';
import MypageScheduleAccessContainer from 'containers/MypageScheduleAccessContainer/MypageScheduleAccessContainer';

export default function MypageScheduleAccessPage() {
    return (
        <MypageScheduleAccessContainer />
    )
}
